import React, { Component, ReactDOM } from "react";
import DeviceFingerprintInput from "../../device-fingerprint/DeviceFingerprint";

export const validation = {
  validateOn: ["blur"],
  validationRegex: /.*/,
  required: false
};

class DeviceFingerprint extends Component {
  render() {
    return (
      <DeviceFingerprintInput
        id="device-fingerprint"
        name="device-fingerprint"
        validation={validation}
      />
    );
  }
}

export default DeviceFingerprint;
